import { useState, createContext, Dispatch, SetStateAction, ReactNode } from 'react';

type OpenModalContextType = {
  values: {
    text: boolean;
    number: boolean;
    image: boolean;
    counter: boolean;
    datetime: boolean;
    options: boolean;
    label: boolean;
  };
}

type OpenModalContextState = {
  isOpen: OpenModalContextType;
  setIsOpen: Dispatch<SetStateAction<OpenModalContextType>>;
}

type OpenModalProviderProps = {
  children: ReactNode;
}

const DEFAULT_VALUE: OpenModalContextState = {
  isOpen: {
    values: {
      text: false,
      number: false,
      image: false,
      counter: false,
      datetime: false,
      options: false,
      label: false
    }
  },
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setIsOpen: () => { }
};

export const OpenContext = createContext<OpenModalContextState>(DEFAULT_VALUE);

export const OpenProvider = ({ children }: OpenModalProviderProps) => {
  const [isOpen, setIsOpen] = useState(DEFAULT_VALUE.isOpen);

  return (
    <OpenContext.Provider
      value={{
        isOpen,
        setIsOpen
      }}
    >
      {children}
    </OpenContext.Provider>
  );
};
